import React, { Component } from "react";
import withRouter from "../withRouter";
import { Outlet } from "react-router-dom";
import { store } from "redux/store";
import { setError } from "redux/Slice/state";
import { TextField, Container as MuiContainer } from "@mui/material";
import { setActiveHotel } from "redux/Slice/hotelSlice";
import { connect } from "react-redux";
import { YieldApi } from "api/yield";
import { AuthService } from "App/services";
import { ThemeProvider } from "@mui/material/styles";
import {
  baseTheme,
  Card,
  LogoImg,
  SearchWrapper,
  HotelCardsGrid,
  CardIcon,
  AddCardIcon,
  UsersIcon,
  CardTitle,
} from "../../mui-theme/base";
import { ACTIONS, hasPermission } from "App/common/permissionHandler";
import { ConfigApi } from "api/config";

let logo: string;
import(`assets/images/${process.env.REACT_APP_STAGE}/revanista-logo.png`).then(
  (module) => {
    logo = module.default;
  },
);

interface Props {
  router: any;
}

interface State {
  counter: number;
  searchInput: string;
}

interface StateProps {
  hotels: any[];
  user: any;
}

interface Props extends StateProps {
  router: any;
}

class HomePage extends Component<Props, State> {
  readonly state: State = {
    counter: 0,
    searchInput: "",
  };

  async componentDidMount(): Promise<void> {
    await AuthService.revanista.user.identify();
  }

  handleOnClick = async (data: any) => {
    const userHotels = this.props.hotels;
    if (userHotels.length !== 0) {
      try {
        const h = await ConfigApi.getHotelConfig(parseInt(data.hotelId));
        store.dispatch(setActiveHotel(h));
      } catch (err) {
        console.error(err);
        store.dispatch(setError(true));
        throw err;
      }
    }
    console.log(data);

    this.props.router.navigate(`${data.hotelId}`);
  };

  handleChange = (e: any) => {
    const value = e.target.value;
    this.setState({ searchInput: value });
  };

  render() {
    if (this.props.hotels.length === 1) {
      const singleUserHotelId = this.props.hotels[0].hotelId;
      const isSignedIn = localStorage.getItem(
        "amplify-authenticator-authState",
      );
      isSignedIn === "signedIn" &&
        this.props.router.navigate(`/${singleUserHotelId}`);
    }
    const { searchInput } = this.state;

    const searchFilter = this.props.hotels.filter((item: any) => {
      if (searchInput.length === 0) {
        return true;
      } else {
        return item.name.toLowerCase().includes(searchInput.toLowerCase());
      }
    });

    return (
      <ThemeProvider theme={baseTheme}>
        <MuiContainer maxWidth={false}>
          <LogoImg
            // onClick={this.handleOnHomePage}
            src={logo}
            alt="Revanista Logo"
          />
          <SearchWrapper>
            <TextField
              // Added width 100% to make it full width
              fullWidth // Make TextField take full width of SearchWrapper
              id="outlined-basic"
              label="Search"
              variant="outlined"
              name="searchHotel"
              inputProps={{ maxLength: 20 }}
              onChange={this.handleChange}
              sx={{
                width: "100%",
              }}
            />
          </SearchWrapper>
          <HotelCardsGrid>
            {hasPermission(ACTIONS.ONBOARD_HOTEL) && (
              <>
                <Card
                  onClick={() => this.props.router.navigate(`/onboard-hotel`)}
                  style={{ cursor: "pointer" }} // Added cursor pointer
                >
                  <AddCardIcon />
                  <CardTitle>Onboard Hotel</CardTitle>
                </Card>
              </>
            )}

            {hasPermission(ACTIONS.MODIFY_HOTELSTAFF) && (
              <>
                <Card
                  onClick={() => this.props.router.navigate(`/admin`)}
                  style={{ cursor: "pointer" }} // Added cursor pointer
                >
                  <UsersIcon />
                  <CardTitle>User Management</CardTitle>
                </Card>
              </>
            )}

            {searchFilter.map((data: any) => {
              return (
                <Card
                  key={data.hotelId}
                  onClick={() => this.handleOnClick(data)}
                  style={{ cursor: "pointer" }} // Added cursor pointer
                >
                  <CardIcon />
                  <CardTitle>{data.name}</CardTitle>
                </Card>
              );
            })}
          </HotelCardsGrid>
          <Outlet />
        </MuiContainer>
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state: any) => ({
  hotels: state.hotelData.hotels,
  user: state.user,
});

export default connect(mapStateToProps)(withRouter(HomePage));
